import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { ButtonV2 } from 'builder/components/Button'

import { Media } from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;

  ${Media.Tablet`
    gap: ${Spacing.S};
    flex-direction: column-reverse;
  `}

  ${Media.Phone`
    gap: ${Spacing.XS};
  `}
`

export const InfoContainer = styled.div`
  flex: 1;
`

export const Text = styled.div`
  ${Typography.Caption}
  ${FontWeights.Regular}

  color: ${Colors.Neutral50};

  ${Media.Tablet`
    text-align: center;
  `}

  strong {
    ${FontWeights.Medium}
  }
`

export const ActionsContainer = styled.div`
  flex: 1;
  display: flex;
  gap: ${Spacing.XS};
  justify-content: flex-end;

  ${Media.Tablet`
    justify-content: center;
  `}
`

export const ActionButton = styled(ButtonV2)`
  ${Media.Tablet`
    width: 100%;
  `}
`
